import PlatformActions from './PlatformActions'

export default class GOGOLIActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'LIVE',
      gameCode: 'GOGOLI-LIVE-001',
      platform: 'GOGOLI',
    }

    this.gameName = 'Speed Track'

    this.constantBetInfo = {
      live: false,
      gmeId: '2',
      gmeTypeCode: 'ST',
      betTypeCode: 'bs',
      betChsCode: 'big',
      odd: 0.95,
      isLive: false,
      betStsCode: 'O',
    }
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
      betNum,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `TRX${txnId}`, // TRX 1783491418005 69cdbb18
      roundId, // 2274411
      betType: null,
      currency,
      betTime, // 2026-07-08T14:16:58.000+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {
        betInfo: [
          {
            rndId: roundId,
            betAmt: betAmount,
            betNum: `DTL${betNum}`, // DTL 1783491418021 1d09a3e3
            ...this.constantBetInfo,
          },
        ],
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      betNum,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `TRX${txnId}`, // TRX178349141800569cdbb18
      refPlatformTxId: null,
      settleType: 'platformTxId',
      updateTime, // 2026-07-08T14:17:27.130+08:00
      roundId,
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        betDtlInfos: [
          {
            betNum: `DTL${betNum}`, // DTL17834914180211d09a3e3
            rfdAmt: null,
          },
        ],
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betAmount,
      betNum,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `TRX${txnId}`, // TRX178349141800569cdbb18
      roundId,
      gameInfo: {
        betInfo: [
          {
            rndId: roundId,
            betAmt: betAmount,
            betNum: `DTL${betNum}`, // DTL17834914180211d09a3e3
            ...this.constantBetInfo,
          },
        ],
      },
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }

  getVoidBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betAmount,
      updateTime,
      betTime,
      betNum,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `TRX${txnId}`, // TRX178349141800569cdbb18
      roundId,
      betAmount,
      updateTime,
      gameInfo: {
        betInfo: [
          {
            rndId: roundId,
            betAmt: betAmount,
            betNum: `DTL${betNum}`, // DTL17834914180211d09a3e3
            ...this.constantBetInfo,
          },
        ],
        voidType: 2,
        roundDate: betTime,
      },
      voidType: 2,
    }))

    const message = {
      action: 'voidBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
